import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from "./reducers/authReducer";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import sideBarReducer from "./reducers/sideBarReducer";

const reducers = combineReducers({
  auth: authReducer,
  sideBarStateChange: sideBarReducer,
});

const persistConfig: any = {
  key: "root",
  storage,
  timeout: null, // Disable timeout to prevent "persist timed out" error
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE", "persist/REGISTER"],
      },
    }),
});

export default store;
export type RootState = ReturnType<typeof store.getState>;
